
import { Options, Vue } from 'vue-class-component'
import Avatar from '@/components/Avatar.vue'

@Options({
  components: {
    Avatar,
  },
})
export default class Parallax extends Vue {
  public isDisable = false

  // TODO: Add directive scroll like the first version
  public handleScroll(evt: any, el: HTMLElement): void {
    const scrollTop: number = evt.currentTarget.scrollTop
    const topElement: number = el.offsetTop + 50
    this.isDisable = scrollTop > topElement
    this.$emit('show-menu', this.isDisable)
  }
}
